import { Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import ColorButton from "components/common/ColorButton";
import { useStyles as useStylesField } from "components/request-document/components/Commons";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkProjectId,
  checkProjectIdSlice,
  selectCheckProjectId,
} from "redux/modules/checkProjectIdSlice";
import {
  m24SwitchModeSlice,
  selectProjectID,
} from "redux/modules/m24SwitchModeSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: "18px 48px",
    width: 820,
  },
  title: {
    color: theme.palette.darkIndigo.main,
  },
  label: {
    color: "#172b4d",
    height: 34,
  },
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    flex: 1,
  },
  currencyCode: {
    margin: theme.spacing(1),
    width: 100,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonUpload: {
    margin: theme.spacing(1),
    height: 54,
    width: 140,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    color: theme.palette.secondary.main,
  },
  uploadStatus: {
    display: "flex",
    flex: 1,
    margin: theme.spacing(1),
    height: 54,
    borderRadius: 7,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    alignItems: "center",
    padding: "0px 17px",
  },
  bulletStatus: {
    width: 18,
    height: 18,
    borderRadius: 18,
    marginRight: theme.spacing(1),
  },
  errorText: {
    marginLeft: theme.spacing(3),
  },
  textBold: {
    color: "#172B4D",
    fontSize: 25,
    fontWeight: "bold",
  },
  successStyles: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2DCE98 !important",
    },
    "& .MuiFormLabel-root.Mui-error": {
      color: "#2DCE98 !important",
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: "#2DCE98 !important",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#2DCE98 !important",
    },
  },
}));

export default function PopupVerifyProjectId({
  onCancel = () => {},
  onSubmit = () => {},
}) {
  const classes = useStyles();
  const classesField = useStylesField();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [projectID, setProjectID] = useState("");

  const projectId = useSelector(selectProjectID);
  const userProfile = useSelector((state) => state.user.profile);
  const smartCompanyID = get(userProfile, "smartCompanyID", null);

  const checkProjectIdState = useSelector(selectCheckProjectId);
  const isPass = get(checkProjectIdState, "data.isPass", false);

  useEffect(() => {
    setProjectID(projectId);
  }, [projectId]);

  useEffect(() => {
    dispatch(checkProjectIdSlice.actions.clearAll());
  }, []);

  useEffect(() => {
    if (!checkProjectIdState.isLoading) {
      if (checkProjectIdState.isSuccess) {
        hideLoading();
      } else if (checkProjectIdState.isFailure) {
        hideLoading();
      }
    }
  }, [checkProjectIdState, dispatch, hideLoading, showLoading]);

  const callAPISubmit = () => {
    showLoading();
    dispatch(checkProjectId({ smartCompanyID, projectID }));
  };
  const handleOnFocus = () => dispatch(checkProjectIdSlice.actions.clearAll());
  const handleChange = (event) => setProjectID(event.target.value);
  const handleBlur = () => callAPISubmit();
  const handleSubmit = (e) => {
    e.preventDefault();
    callAPISubmit();
  };

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        QUALIFICATION ENDORSEMENT FOR TEMPORARY 24
      </Typography>
      <Typography variant="h4" color="secondary">
        Qualifications and Criteria
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={1} style={{ marginTop: 30 }}>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              color="secondary"
              className={classes.textBold}
            >
              Verify Application number for investment promotion
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Input Application number for investment promotion"
              className={clsx(classesField.textField, {
                [classes.successStyles]: isPass,
              })}
              variant="outlined"
              value={projectID}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleOnFocus}
              error={checkProjectIdState.isFailure || isPass}
              helperText={
                isPass
                  ? "Success"
                  : checkProjectIdState.isFailure
                  ? checkProjectIdState.error?.message
                  : " "
              }
            />
          </Grid>
          <Grid item xs={12} style={{ marginTop: 30 }} />
          <Grid item xs={12} md={4} />
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="outlined"
              onClick={onCancel}
              type="button"
            >
              Cancel
            </ColorButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="contained"
              color="secondary"
              disabled={!isPass}
              onClick={() => {
                dispatch(m24SwitchModeSlice.actions.setProjectId(projectID));
                onSubmit();
              }}
              type="button"
            >
              Next
            </ColorButton>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
